import React from "react";

import { useOutletContext, useNavigate, useParams } from "react-router-dom";

import Service from '../../util/Service';
import HtmlContent from "../util/HtmlContent";
import { Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Paper, Stack, Tooltip, Typography } from "@mui/material";
import KanbanNovoDialog from "./kanban/KanbanNovoDialog";
import ProjectForm from "./ProjectForm";
import { ArrowBackIos, Visibility } from "@mui/icons-material";
import EscolheUserPopover from "../page/user/EscolheUserPopover";
import PapeisPanel from "../page/portal/setting/PapeisPanel";
import MembrosAvatarGroup from "./MembrosAvatarGroup";
import { useProfile } from "../common/useProfile";
import { temAcessoAoProjeto } from "./ProjetoRoot";
import ProjetoRemoverArquivar from "./ProjetoRemoverArquivar";
import RulesPopover from "../page/portal/user/RulesPopover";

export default function ProjetoPage() {
    const { update } = useOutletContext();
    const navigate = useNavigate();
    const params = useParams();
    const [projeto, setProjeto] = React.useState();
    const [openNewKanban, setOpenNewKanban] = React.useState(false);
    const [edicaoProjeto, setEdicaoProjeto] = React.useState(false);
    const prof = useProfile();
    const [papeis, setPapeis]= React.useState();
    const [membroToAdd, setMembroToAdd] = React.useState();
    const [openPapel, setOpenPapel] = React.useState(false);
    const [openUserPapel, setOpenUserPapel] = React.useState(false);
    const [temAcessoBasico, setTemAcessoBasico] = React.useState(null);
    const [lstUser, setLstUser] = React.useState();

    React.useEffect(() => {
        if( prof.isOk && !projeto){
            buscaProjeto();
            buscaPapeis();
            buscaUser();
        }
    }, [prof])

    React.useEffect(() => {
        if( prof.profile && projeto && papeis && lstUser){
            const bool = temAcessoAoProjeto(projeto, prof, papeis, ['rootProject', 'ProjectAdm', 'PrjAddMembros']);
            console.log('>>>>', bool)
            setTemAcessoBasico(bool);
        // }
    // }, [prof.profile, projeto, papeis]);

    // React.useEffect(() => {
        // if (projeto) {
            const id = projeto.isRedmine?"redmine_"+projeto.id:projeto.id;
            const comp = {
                title: {
                    variant: 'h6',
                    txt: projeto.nome
                },
                actions: [],
            };
            if (projeto.membros) {
                comp.membros = <MembrosAvatarGroup membros={projeto.membros} remove={handleRemoveMembro} action={handleUserClick}/>
            }

            if( prof.temAcesso("rootProject") || prof.temAcesso("ProjectAdm")){
                comp.actions.push({
                    nome: 'Editar Projeto',
                    ac: editarProjeto
                });
                comp.actions.push({
                    nome: 'Kaban',
                    ac: "/project/kanban/" + id
                });
                comp.actions.push({
                    nome: 'Novo Kanban',
                    ac: NovoKanban
                });
                comp.actions.push({
                    nome: 'Divider'
                });
                comp.actions.push({
                    nome: 'projVisibilidade',
                    ac: <EscolheUserPopover membros={projeto.membros} action={handleMembroToAdd} lst={lstUser} temAcessoBasico={true}/>
                });
                comp.actions.push({
                    nome: 'EscolheUser',
                    ac: 
                    // <RulesPopover showTxt={true} />
                    <Button startIcon={<Visibility />} size='small'
                    >
                        Visibilidade
                    </Button>
                });
                comp.actions.push({
                    nome: 'Divider'
                });
                comp.actions.push({
                    nome: 'EscolheUser',
                    ac: <ProjetoRemoverArquivar projeto={projeto} action={()=> navigate("../")}/>
                });
                
            }else if( temAcessoAoProjeto(projeto, prof, papeis, ["ProjectAdm", "PrjAdm"])){
                comp.actions.push({
                    nome: 'Kaban',
                    ac: "/project/kanban/" + id
                });
                comp.actions.push({
                    nome: 'Novo Kanban',
                    ac: NovoKanban
                });
                comp.actions.push({
                    nome: 'Divider'
                });
                comp.actions.push({
                    nome: 'EscolheUser',
                    ac: <EscolheUserPopover membros={projeto.membros} action={handleMembroToAdd} lst={lstUser} temAcessoBasico={true}/>
                });
            }else{
                if( temAcessoAoProjeto(projeto, prof, papeis, ["PrjVerKanban"])){
                    comp.actions.push({
                        nome: 'Kaban',
                        ac: "/project/kanban/" + id
                    });
                }
                if( temAcessoAoProjeto(projeto, prof, papeis, ["PrjAddMembros"])){
                    comp.actions.push({
                        nome: 'EscolheUser',
                        ac: <EscolheUserPopover membros={projeto.membros} action={handleMembroToAdd} lst={lstUser} temAcessoBasico={temAcessoBasico}/>
                    });
                }
                
            }
            
            update(comp);
            if( projeto.isRedmine === true && projeto.pagina === 'busca'){
                buscaPagina();
            }
        }
    }, [projeto, edicaoProjeto, prof.profile, papeis, lstUser])

    function buscaUser() {
        Service.GET("/api/security/user/findAll").then(ret => {
            setLstUser(ret);
        })
    }
    const handleRemoveMembro = (m) => {

        const dado = {
            id: params.id,
            idMembro: m.id
        }

        Service.POST('/api/security/projeto/removeMembro', dado).then(r => {
            if (r.success) {
                handleClosePapel();
                buscaProjeto();
            } else {
                alert(r.msg);
            }
        })
    }
    const handleClosePapel = () => {
        setOpenPapel(false);
    };
    const handleCloseUserPapel=()=>{
        setOpenUserPapel(false);
    }
    const handleUserClick=(user)=>{
        setOpenUserPapel(true);
        console.log( user);
        setMembroToAdd(user);
    }
    function buscaPapeis(){
        Service.GET('/api/security/setting/buscaByTipo/papel').then(r => setPapeis(r));
    }
    function buscaProjeto() {
        const id = params.id;
        console.log( id )
        if( id.includes("redmine")){
            let rdId = id.replace("redmine_", '');
            Service.GET("/api/security/integration/redmine/project/" + rdId).then(r => {
                console.log(r);
                if (r) {
                    const proj = r.project;
                    setProjeto({
                        id: proj.id,
                        nome: proj.name,
                        descricao: proj.description,
                        isRedmine: true,
                        pagina: 'busca',
                        wrapper: proj
                    });
                    // update(r.membros);
                }
            });
        }else{
            Service.GET("/api/projeto/porId/" + id).then(r => {
                if (r) {
                    if( r.rule !== null && r.rule.length > 1){
                        if(prof.temAcesso(r.rule)){
                            setProjeto(r);
                        }else{
                            alert('Não tem acesso para ver esse projeto!');
                            navigate("/project");
                            return;
                        }
                    }else{
                        setProjeto(r);
                    }
                    update(r.membros);
                }
            });
        }
    }
    function buscaPagina(){
        Service.GET("/api/paginaHtml/buscaPorNome/" + projeto.nome).then(r => {
            if (r && r.length > 0){
                setProjeto({
                    ...projeto,
                    pagina: r[0].pagina
                }); 
            }else{
                setProjeto({
                    ...projeto,
                    pagina: ''
                });
            }     
        })
    }
    function hadleAddPapel(papel) {
        const dado = {
            id: params.id,
            membro: membroToAdd
        }
        dado.membro.papel = papel;
        console.log( dado );
        
        Service.POST('/api/security/projeto/incluirMembro', dado).then(r => {
            if (r.success) {
                // setKanban(r.dado);
                handleClosePapel();
                handleCloseUserPapel();
                // window.location.reload(true);
                // update( r.dado.membros );
                buscaProjeto();
            } else {
                alert(r.msg);
            }
        })
    }
    function handleMembroToAdd(m) {
        setMembroToAdd(m);
        setOpenPapel(true);
    }

    function NovoKanban() {
        setOpenNewKanban(true)
    }
    function editarProjeto() {
        setEdicaoProjeto(true);
    }

    if (edicaoProjeto) {
        return (
            <React.Fragment>
                <Tooltip title="Voltar"
                    sx={{ float: 'left', ml: 0, mt: 0 }}
                >
                    <IconButton aria-label="edit" color="primary"
                        onClick={() => {
                            setEdicaoProjeto(false);
                        }}
                    >
                        <ArrowBackIos />
                    </IconButton>
                </Tooltip>
                <ProjectForm 
                    projeto={projeto} 
                    setEdicao={setEdicaoProjeto}
                    action={(p) => {
                        // setEdicaoProjeto(false);
                        setProjeto(p);
                    }}
                />
            </React.Fragment>
        )
    }
    return (
        <div>
            <HtmlContent htmlString={projeto? projeto.pagina:""} edit={false} />

            <KanbanNovoDialog open={openNewKanban} setOpen={setOpenNewKanban} />

            <Dialog open={openPapel} onClose={handleClosePapel} maxWidth="md" fullWidth>
                <DialogTitle>Papel no projeto</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Defina qual papel o membro <strong>{membroToAdd && membroToAdd.nome}</strong> terá no projeto.
                    </DialogContentText>
                    <Paper>
                        <PapeisPanel actionAddPapel={hadleAddPapel} />
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosePapel}>Cancel</Button>
                    {/* <Button type="submit" form="subscription-form">
                    Subscribe
                </Button> */}
                </DialogActions>
            </Dialog>

            <Dialog open={openUserPapel} onClose={handleCloseUserPapel} maxWidth="md" fullWidth>
                <DialogTitle>Membro {membroToAdd && membroToAdd.nome+" - "+membroToAdd.papel}</DialogTitle>
                <DialogContent>
                    {/* <DialogContentText>                         */}
                        <Stack spacing={1}>
                            <p><strong>Nome: </strong> {membroToAdd && membroToAdd.nome}</p>
                            <p><strong>Email: </strong>{membroToAdd && membroToAdd.email}</p>
                            <p><strong>Papel: </strong>{membroToAdd && membroToAdd.papel}</p>
                        </Stack>
                    {/* </DialogContentText> */}
                    <Typography align="center">Mudar de papel:</Typography>
                    <Paper>
                        <PapeisPanel actionAddPapel={hadleAddPapel} />
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseUserPapel}>Cancel</Button>
                    {/* <Button type="submit" form="subscription-form">
                    Subscribe
                </Button> */}
                </DialogActions>
            </Dialog>
        </div>
    )
    return (
        <Container >
            <Paper>
                <Stack>
                    {projeto &&
                        <Typography variant="h6" component="h2" style={{ textAlign: "center" }}>
                            {projeto.descricao}
                        </Typography>}
                    <HtmlContent htmlString={projeto ? projeto.pagina : ''} />
                    {!projeto &&
                        <Typography variant="h6" component="h2" style={{ textAlign: "center" }}>
                            Projeto não encontrado!
                        </Typography>}
                </Stack>
            </Paper>
            <KanbanNovoDialog open={openNewKanban} setOpen={setOpenNewKanban} />

            <Dialog open={openPapel} onClose={handleClosePapel} maxWidth="md" fullWidth>
                <DialogTitle>Papel no projeto</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Defina qual papel o membro <strong>{membroToAdd && membroToAdd.nome}</strong> terá no projeto.
                    </DialogContentText>
                    <Paper>
                        <PapeisPanel actionAddPapel={hadleAddPapel} />
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClosePapel}>Cancel</Button>
                    {/* <Button type="submit" form="subscription-form">
                    Subscribe
                </Button> */}
                </DialogActions>
            </Dialog>

            <Dialog open={openUserPapel} onClose={handleCloseUserPapel} maxWidth="md" fullWidth>
                <DialogTitle>Membro {membroToAdd && membroToAdd.nome+" - "+membroToAdd.papel}</DialogTitle>
                <DialogContent>
                    {/* <DialogContentText>                         */}
                        <Stack spacing={1}>
                            <p><strong>Nome: </strong> {membroToAdd && membroToAdd.nome}</p>
                            <p><strong>Email: </strong>{membroToAdd && membroToAdd.email}</p>
                            <p><strong>Papel: </strong>{membroToAdd && membroToAdd.papel}</p>
                        </Stack>
                    {/* </DialogContentText> */}
                    <Typography align="center">Mudar de papel:</Typography>
                    <Paper>
                        <PapeisPanel actionAddPapel={hadleAddPapel} />
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseUserPapel}>Cancel</Button>
                    {/* <Button type="submit" form="subscription-form">
                    Subscribe
                </Button> */}
                </DialogActions>
            </Dialog>
        </Container>
    )
}
